import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const fmtQty = (n) => (n == null ? "0" : Number(n).toLocaleString("cs-CZ", { maximumFractionDigits: 3 }));

// Výdej na zakázku (§7). Žádný výběr cíle — cíl se odvozuje ze skladu; jen MANAGER
// z centrálu vybírá svou zakázku. Povinné: komu vydáváte + množství.
export function IssueDialog({ item, warehouse, team, showProjectSelect, projects, busy, onSubmit, onClose }) {
  const [received_by, setReceiver] = useState("");
  const [qty, setQty] = useState("");
  const [note, setNote] = useState("");
  const [project_id, setProject] = useState("");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const receivers = (team || []).filter((u) => u.status === "active");

  const subtitle = warehouse?.type === "central"
    ? "Materiál jde do přímé spotřeby. Na jinou stavbu použij převodku."
    : `Materiál jde na zakázku ${warehouse?.name || "—"}. Na jinou stavbu použij převodku.`;

  const submit = () => {
    if (!received_by) return;
    if (showProjectSelect && !project_id) return;
    onSubmit({ received_by, qty, note, date, project_id: showProjectSelect ? project_id : undefined });
  };
  const over = Number(qty) > (item.qty || 0);

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto" data-testid="issue-dialog">
        <DialogHeader>
          <DialogTitle>Výdej — {item.name}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3.5">
          <p className="text-sm text-muted-foreground">{subtitle} · na skladě {fmtQty(item.qty)} {item.unit}</p>
          {showProjectSelect && (
            <div>
              <Label>Zakázka *</Label>
              <Select value={project_id} onValueChange={setProject}>
                <SelectTrigger className="h-11 mt-1 w-full min-w-0" data-testid="issue-project-select"><SelectValue placeholder="Vyberte svou zakázku" /></SelectTrigger>
                <SelectContent>{projects.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}</SelectContent>
              </Select>
            </div>
          )}
          <div>
            <Label>Komu vydáváte *</Label>
            <Select value={received_by} onValueChange={setReceiver}>
              <SelectTrigger className="h-11 mt-1 w-full min-w-0" data-testid="issue-receiver-select"><SelectValue placeholder="Vyberte příjemce" /></SelectTrigger>
              <SelectContent>{receivers.map((u) => <SelectItem key={u.id} value={u.id}>{u.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label>Množství * ({item.unit})</Label>
            <Input type="number" step="0.001" value={qty} onChange={(e) => setQty(e.target.value)} className="h-11 mt-1 w-full min-w-0" data-testid="issue-qty" />
            {over && <p className="text-xs text-destructive mt-1">Na skladě je jen {fmtQty(item.qty)} {item.unit}.</p>}
          </div>
          <div>
            <Label>Datum spotřeby</Label>
            <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="h-10 mt-1 w-full min-w-0" data-testid="issue-date" />
            <p className="text-xs text-muted-foreground mt-1">Den, kdy se materiál na stavbě spotřeboval — objeví se v deníku toho dne.</p>
          </div>
          <div>
            <Label>Poznámka</Label>
            <Input value={note} onChange={(e) => setNote(e.target.value)} className="h-11 mt-1 w-full min-w-0" data-testid="issue-note" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" className="w-full md:w-auto" onClick={onClose}>Zrušit</Button>
          <Button className="w-full md:w-auto" onClick={submit} disabled={busy || over || !received_by || !qty || (showProjectSelect && !project_id)} data-testid="issue-confirm">
            {busy ? "Ukládám…" : "Vydat"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
